import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ITimeLine } from '../../model/timeline.dto';
import { SignUpStateService } from '../../../sign-up-process/services/sign-up-state.service';
import { TenantConfigService } from '../../../../../../../tenant-config/tenant-config.service';

@Component({
  selector: 'hfc-standalone-form-container',
  templateUrl: './standalone-form-container.component.html',
  styleUrls: ['./standalone-form-container.component.scss']
})
export class StandaloneFormContainerComponent {
  @Input() timeLineContent?: ITimeLine[];
  @Input() showTimeLine?: boolean = false;
  @Input() showButtons = false;
  @Input() showCopyright = false;
  @Input() stepNumber: number;
  @Input() nextLabel?: string;
  @Input() backLabel?: string;
  @Input() nextDisabled = false;

  @Output() nextAction = new EventEmitter<any>();
  @Output() backAction = new EventEmitter<any>();

  public currentYear: number = new Date().getFullYear();

  /** Client login background from the tenant config; consumed by the :host desktop rule in the scss. */
  @HostBinding('style.--client-login-bg')
  public get clientLoginBackgroundCss(): string {
    return `url('${this.tenantConfigService.clientLoginBackgroundUrl}')`;
  }

  constructor(
    public readonly signUpStateService: SignUpStateService,
    public readonly tenantConfigService: TenantConfigService
  ) {}
}
